import { useEffect } from "react";
import { useSelector } from "react-redux";

import DefRoutes from "../../routes/routes.json";
import t from "../../i18n/i18n";
import initPage from "../../utils/initPage";

import Template from "../../template/template";
import Aside from "./aside/aside";
import UserForm from "./userForm/userForm";
import Notify from "../../components/notification/notify";
import queryString from "query-string";

function Profile() {
  initPage({ title: t("Profile.Title") });
  useEffect(() => {
    const query = queryString.parse(window.location.search);
	console.log(query);
	
    if (query.status && query.gateway) {
      function defineType(status) {
        switch (status) {
          case "PAID":
            return "success";
          case "CANCELED":
            return "danger";
          case "WAIT":
            return "warning";
          default:
            return "danger";
        }
      }

      Notify({
        type: defineType(query.status),
        message: t(`PaymentMessage.${query.status}`, { gateway: query.gateway }),
      });
    }
  }, []);

  const { logged } = useSelector((store) => store.auth);

  if (!logged) {
    return (window.location = DefRoutes.SignIn);
  }

  return (
    <Template>
      {logged ? (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="inside-warp">
                <div className="col-sidebar">
                  <div className="mobile-side-btn">
                    <button type="button" className="side-toggle">
                      <i className="fal fa-cog"></i>
                    </button>
                  </div>
                  <div className="sidebar-main">
                    <Aside />
                  </div>
                </div>

                <div className="col-contentbar">
                  <div className="user-profile-form">
                    <UserForm />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div style={{ height: window.screen.height / 1.5 }} />
      )}
    </Template>
  );
}

export default Profile;
